<script>
import Global from './GlobalVariable';
import axios from 'axios';

export default {
   name: 'ServiceHelper',
   methods: {   
      showLoading() {
         document.getElementById("ltc-loading").style.display = "";
      },
      hideLoading() {
         document.getElementById("ltc-loading").style.display = "none";
      },
      dateStrFormat: function(date){
         var datetimeAr = date.split("T");
         var dateStr = datetimeAr[0];
         var timeStr = (datetimeAr[1]).substring(0,8);
         return dateStr+" "+timeStr;
      },
      copyJsonObject: function(originalObject){
         var newJsonObject = JSON.parse(JSON.stringify(originalObject))
         return newJsonObject;
      },
      isTokenExpire: function(error){
         var vm = this;
         if (error.response&&error.response.status === 401) {
            vm.$swal.fire({
            title: 'You session has been expired!',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'OK',
            // denyButtonText: `No`,
            }).then((result) => {
            if (result.isConfirmed) {
               vm.$router.push("/");
            } 
            });
         }
      },
      getSurveyGroup: async function(keyword="",isActive=false){
         var vm = this;
         var request = {};
         request["keyword"] = keyword;
         request["isActive"] = isActive;
         vm.showLoading();
            return await axios.post(Global.backendPath+"survey/getSurveyGroup", request,
            {
                  headers: {
                  "Authorization": localStorage.getItem("token")
                  }
            })
            .then((response) => {
            vm.hideLoading();
            return response;
            }).catch((error) => {
            vm.hideLoading();
            console.log(error);
            vm.isTokenExpire(error);

            });
      },
      validateDatePeriod: function(start_date, end_date) {
        var flag = true;
        var msg = "";
        if(!start_date||!end_date){
         flag = false;
         msg+="<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Please choose Start Date and End Date! </div><br>";
        }else{
         console.log("start_date",start_date);
         console.log("end_date",end_date);
         var startDate = new Date(start_date);
         var endDate = new Date(end_date);
         var diff = endDate - startDate;
         var days = diff / (1000 * 60 * 60 * 24);
            if(startDate.getTime()>endDate.getTime()){
                  flag = false;
                  msg+="<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Start date older than End date! </div><br>";
            } 
            if(days > 30){
                  flag = false;
                  msg+="<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Period date more than 30 days! </div><br>";
            }
        }
        return {"flag":flag,"msg":msg};
    },
    getSurveyDetails: async function(userId,startDate,endDate){
         var vm = this;
         var request = {};
         request["userId"] = userId
         request["startDate"] = startDate
         request["endDate"] = endDate
         vm.showLoading();
            return await axios.post(Global.backendPath+"report/getSurveyDetails", request,
            {
                  headers: {
                  "Authorization": localStorage.getItem("token")
                  }
            })
            .then((response) => {
            vm.hideLoading();
            return response;
            }).catch((error) => {
            vm.hideLoading();
            console.log(error);
            vm.isTokenExpire(error);
            });
    },
    JSONtoCSV:function(jsonArray) {
    // Check if the jsonArray is not empty
    if (jsonArray.length == 0) {
        return null;
    }
    // Create CSV headers
    let csvHeaders = Object.keys(jsonArray[0]).join(',') + '\n';

    // Create CSV rows
    let csvRows = jsonArray.map(row => {
        return Object.values(row).join(',');
    }).join('\n');

    // Combine CSV headers and rows
    let csvString = csvHeaders + csvRows;

    return csvString;
   },
   downloadCSVFileBackup:function(data, filename = 'data.csv') {
    let csvFile = new Blob([data], { type: 'text/csv' });
    let downloadLink = document.createElement('a');

    // Create a link to the file
    downloadLink.download = filename;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = 'none';

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();
   },
   getSurveyDetailsArea: async function(userId,startDate,endDate,districtId,provinceId){
         var vm = this;
         var request = {};
         request["userId"] = userId
         request["startDate"] = startDate
         request["endDate"] = endDate
         request["districtId"] = districtId
         request["provinceId"] = provinceId
         vm.showLoading();
            return await axios.post(Global.backendPath+"report/getSurveyDetailsArea", request,
            {
                  headers: {
                  "Authorization": localStorage.getItem("token")
                  }
            })
            .then((response) => {
            vm.hideLoading();
            return response;
            }).catch((error) => {
            vm.hideLoading();
            console.log(error);
            vm.isTokenExpire(error);
            });
    },
   downloadCSVFile:function(data, filename = 'data.csv') {
    let BOM = '\uFEFF';
    let csvFile = new Blob([BOM + data], { type: 'text/csv;charset=utf-8;' });
    let downloadLink = document.createElement('a');

    // Create a link to the file
    downloadLink.download = filename;

    // Create a URL to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = 'none';

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();
   }
   }
};
</script>
